<template>
    <div class="mobile-container">
        <typeOne :type="type" :missiveId="missiveId" v-if="type == 1" :title="title" @submit="submit" />
        <typeTwoOrThree :type="type" :missiveId="missiveId" v-if="type == 2 || type == 3" :title="title" @submit="submit" />
        <typeFour :type="type" :missiveId="missiveId" v-if="type == 4" :title="title" @submit="submit" />
        <success v-if="type === 'success'"></success>
    </div>
</template>

<script>
import typeOne from "./component/typeOne.vue"
import typeTwoOrThree from "./component/typeTwoOrThree.vue"
import typeFour from "./component/typeFour.vue"
import success from "./component/success.vue"
export default {
    name: "mobile",
    data() {
        return {
            type: "",
            missiveId: ""
        }
    },

    components: {
        typeOne,
        typeTwoOrThree,
        typeFour,
        success
    },
    created() {
        this.type = this.$route.query.type || ""
        this.missiveId = this.$route.query.id || ""
    },
    computed: {
        title() {
            if (this.type === "1") {
                return "公函审批"
            } else if (this.type == "2") {
                return "护照换发审批"
            } else if (this.type == "3") {
                return "注销护照审批"
            } else if (this.type == "4") {
                return "企业备案审批"
            } else {
                return ""
            }
        }
    },
    methods: {
        submit() {
            console.log("最终提交了")
            this.type = "success"
        }
    }
}
</script>

<style lang="scss" scoped>
.mobile-container {
    min-height: 100vh;

    display: flex;
    flex-direction: column;
    height: 100vh; // 设置固定高度
    overflow: hidden; // 防止整体滚动
}
</style>
